import { render, staticRenderFns } from "./SectionGifts.vue?vue&type=template&id=706cdf41&"
import script from "./SectionGifts.vue?vue&type=script&lang=js&"
export * from "./SectionGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports